/** @jsx jsx */
import React,{ useEffect } from "react"
import { css, jsx } from '@emotion/react'
import styled from '@emotion/styled';
import { useLocalization } from "gatsby-theme-i18n";
import { graphql } from 'gatsby';
import Seo from "../components/SEO"
import PageHeadline from '../components/PageHeadline';
import IntroductionSection from '../sections/common/IntroductionSection';
import MarkdownSection from '../sections/common/MarkdownSection';
import { P, Ul, H2, HeadlineWrapper,HeadlineIcon } from "../components/StyledComponents";
import AnimatedSection from '../components/AnimatedSection';
import RoundButton from '../components/RoundButton';
import * as breakpoint from '../styles/breakpoints.module.scss';
import * as config from '../styles/config.module.scss';
import { parseHTML } from '../functions/common'
import parse from 'html-react-parser';
import CrosssiteBannerSection from '../sections/common/CrosssiteBannerSection';
import TicketSection from '../sections/ticket/TicketSection'
import CyalumeSection from '../sections/ticket/CyalumeSection'
import CommonSection from '../components/CommonSection'; 




const TicketPage = ({ data }) => {
  
  const { t, addString, localeKey } = useLocalization();

  useEffect(() => {
    addString('ticket',data.allTicketCsv.nodes)
  },[addString,data]);
  
  
  
  return (
  <React.Fragment>
    <Seo 
      title={data.pageTitle[localeKey]} 
      description={data.pageDescription[localeKey]}  /> 
    <PageHeadline category={t('ticket.page.category.label')} title={t('ticket.page.display.title')}/>
    <AnimatedSection>
      <IntroductionSection narrow={"true"} css={css`
        @media only screen and (max-width: ${breakpoint.smMax}){
          padding-bottom:0;
        }
      `}>
        <P align={'left'} css={css`
          font-size: ${config.fontSizeNormal};
          margin-bottom:48px;
          line-height: 24px;
          
          p{
            margin-bottom:1.75em;
          }

          @media only screen and (max-width: ${breakpoint.xsMax}){
            margin-bottom:16px;
            font-size: 14px;

          }
        `}>{parseHTML(t('ticket.intro.description'))}</P>
        <P align={'left'}>
          <Ul color={'#C62828'}>
            <li>{parseHTML(t('ticket.intro.attention.item01'))}</li>
            <li>{parseHTML(t('ticket.intro.attention.item02'))}</li>
            <li>{parseHTML(t('ticket.intro.attention.item03'))}</li>
          </Ul>
        </P>
      </IntroductionSection>
      <ButtonContainer>
        <RoundButton color={"#4E4E50"} size={"large"} fixedwidth="true" to={`/jp/about/`} css={css`
          margin-right:32px;
          @media only screen and (max-width: ${breakpoint.smMax}){
            width:288px;
            height:48px;
            line-height:48px;
            font-size: 16px;
            line-height: 24px;
          }

          @media only screen and (max-width: ${breakpoint.xsMax}){
            margin-right:0px;
            width:calc(100% - 48px);
            line-height:36px;
            height:36px;
            font-size: 14px;
            line-height: 20px;
          }
        `}>
          {t('ticket.ticket.about.button.label')}
        </RoundButton>
        <RoundButton color={"#F50057"} size={"large"} fixedwidth="true" href={t('ticket.ticket.entry.button.url')} css={css`
          
          @media only screen and (max-width: ${breakpoint.smMax}){
            width:288px;
            height:48px;
            line-height:48px;
            font-size: 16px;
            line-height: 24px;
          }

          @media only screen and (max-width: ${breakpoint.xsMax}){
            width:calc(100% - 48px);
            line-height:36px;
            height:36px;
            font-size: 14px;
            line-height: 20px;
          }
        `}>
          {t('ticket.ticket.entry.button.label')}
        </RoundButton>
      </ButtonContainer>
    </AnimatedSection>

    <CommonSection  css={css`
      > div{
        padding-bottom:48px;
      }
    `}> 
      <AnimatedSection>
        <HeadlineWrapper align={'center'}>
          <HeadlineIcon type={'Meteor'} color={'#D00F31'} css={css`
            margin:0 auto 16px;
            @media only screen and (max-width: ${breakpoint.smMax}){
              margin:0 auto 12px;
            }
            `}/>
          <H2>{t('ticket.prerequisite.title')}</H2>
        </HeadlineWrapper>
        <TicketSection />
      </AnimatedSection>
      <AnimatedSection>
        <CyalumeSection image={data.img_cyalume}/>
      </AnimatedSection>
    </CommonSection>
      
    <AnimatedSection>
      <MarkdownSection title={data.aboutTxt.childMarkdownRemark.frontmatter.title}>
        {parse(data.aboutTxt.childMarkdownRemark.html)}
      </MarkdownSection>
      </AnimatedSection>
      
      <AnimatedSection>
      <MarkdownSection title={data.entryTxt.childMarkdownRemark.frontmatter.title}>
        {parse(data.entryTxt.childMarkdownRemark.html)}
      </MarkdownSection>
      </AnimatedSection>

      <AnimatedSection>
      <MarkdownSection title={data.purchaseTxt.childMarkdownRemark.frontmatter.title}>
        {parse(data.purchaseTxt.childMarkdownRemark.html)}
      </MarkdownSection>
      </AnimatedSection>

      <AnimatedSection>
      <MarkdownSection title={data.cancelTxt.childMarkdownRemark.frontmatter.title}>
        {parse(data.cancelTxt.childMarkdownRemark.html)}
      </MarkdownSection>
      </AnimatedSection>

      <AnimatedSection>
      <MarkdownSection title={data.viewingTxt.childMarkdownRemark.frontmatter.title}>
        {parse(data.viewingTxt.childMarkdownRemark.html)}
      </MarkdownSection>
      </AnimatedSection>

      <AnimatedSection>
      <MarkdownSection title={data.noticeTxt.childMarkdownRemark.frontmatter.title}>
        {parse(data.noticeTxt.childMarkdownRemark.html)}
      </MarkdownSection>
      </AnimatedSection>

      <AnimatedSection>
      <MarkdownSection title={data.conoraTxt.childMarkdownRemark.frontmatter.title}>
        {parse(data.conoraTxt.childMarkdownRemark.html)}
      </MarkdownSection>
      </AnimatedSection>
      
      <AnimatedSection>
        <ButtonContainer>
          <RoundButton color={"#F50057"} size={"large"} fixedwidth="true" href={t('ticket.ticket.entry.button.url')} css={css`
            
            @media only screen and (max-width: ${breakpoint.smMax}){
              width:288px;
              height:48px;
              line-height:48px;
              font-size: 16px;
              line-height: 24px;
            }

            @media only screen and (max-width: ${breakpoint.xsMax}){
              width:calc(100% - 48px);
              line-height:36px;
              height:36px;
              font-size: 14px;
              line-height: 20px;
            }
          `}>
            {t('ticket.ticket.entry.button.label')}
          </RoundButton>
        </ButtonContainer>
      </AnimatedSection>
    
    <CrosssiteBannerSection />
  </React.Fragment>
)}

export default TicketPage

export const query = graphql`
  query TicketPageQuery {
    pageTitle : ticketCsv(key: {regex: "/^page.title/"}) {
      ...localizedContent
    }
    pageDescription : ticketCsv(key: {regex: "/^page.description/"}) {
      ...localizedContent
    }
    pageKeywords : ticketCsv(key: {regex: "/^page.keywords/"}) {
      ...localizedContent
    }

    allTicketCsv {
      nodes {
        ...localizedContent
      }
    }

    img_cyalume : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/cyalume.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    aboutTxt: file(sourceInstanceName: {eq: "markdown"}, relativePath: {eq: "ticket/section_1_about.md"}) {
      childMarkdownRemark {
        html
        frontmatter {
          title
        }
      }
    }
    entryTxt: file(sourceInstanceName: {eq: "markdown"}, relativePath: {eq: "ticket/section_2_entry.md"}) {
      childMarkdownRemark {
        html
        frontmatter {
          title
        }
      }
    }
    purchaseTxt: file(sourceInstanceName: {eq: "markdown"}, relativePath: {eq: "ticket/section_3_purchase.md"}) {
      childMarkdownRemark {
        html
        frontmatter {
          title
        }
      }
    }
    cancelTxt: file(sourceInstanceName: {eq: "markdown"}, relativePath: {eq: "ticket/section_4_cancel.md"}) {
      childMarkdownRemark {
        html
        frontmatter {
          title
        }
      }
    }
    viewingTxt: file(sourceInstanceName: {eq: "markdown"}, relativePath: {eq: "ticket/section_5_viewing.md"}) {
      childMarkdownRemark {
        html
        frontmatter {
          title
        }
      }
    }
    noticeTxt: file(sourceInstanceName: {eq: "markdown"}, relativePath: {eq: "ticket/section_6_notice.md"}) {
      childMarkdownRemark {
        html
        frontmatter {
          title
        }
      }
    }
    conoraTxt: file(sourceInstanceName: {eq: "markdown"}, relativePath: {eq: "ticket/section_7_conora.md"}) {
      childMarkdownRemark {
        html
        frontmatter {
          title
        }
      }
    }
    
  }
`

const ButtonContainer = styled.div`
  padding:48px 0 96px;
  text-align: center;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:0px 0 58px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:20px 0 20px;
    text-align:center;

    a{
      display:block;
      margin:0 auto;
      &:nth-of-type(1){
        margin-bottom:12px;
      }
    }
  }
`
